export default {
  SET_QUESTIONS: (state, questions) => {
    state.questions = questions.sort((a, b) => {
      return parseInt(a.label, 10) - parseInt(b.label, 10);
    });
  },

  REMOVE_QUESTION: (state, questionId) => {
    state.questions = state.questions.filter(
      (question) => question._id !== questionId
    );
  },
  LOCAL_UPDATE_QUESTION: (state, updatedQuestion) => {
    const index = state.questions.findIndex(
      (question) => question._id === updatedQuestion._id
    );
    if (index !== -1) {
      state.questions.splice(index, 1, updatedQuestion);
    } else {
      state.questions.push(updatedQuestion);
    }
  },

  CHANGE_QUESTIONS_ORDER: (state, payload) => {
    const { question, targetQuestion } = payload;

    // Find the indices of the questions
    const questionIndex = state.questions.findIndex((q) => q._id === question);
    const targetIndex = state.questions.findIndex(
      (q) => q._id === targetQuestion
    );

    if (questionIndex === -1 || targetIndex === -1) {
      console.error('Invalid question or targetQuestion label');
      return;
    }

    const questionObject = state.questions[questionIndex];
    const targetQuestionObject = state.questions[targetIndex];

    if (
      questionObject.parentId &&
      questionObject.parentId !== targetQuestionObject.parentId
    ) {
      console.error('Questions must have the same parentId to be reordered');
      return;
    }

    if (!questionObject.parentId && targetQuestionObject.parentId) {
      console.error('Cannot move a parent question under a child question');
      return;
    }

    // Reorder the questions array
    const reorderedQuestions = [...state.questions];
    const questionToMove = reorderedQuestions.splice(questionIndex, 1)[0];
    reorderedQuestions.splice(targetIndex, 0, questionToMove);

    // Update labels based on the new order
    let index = 0;
    const newLabels = reorderedQuestions.map((q) => {
      if (!q.parentId) {
        index += 1;
        return {
          ...q,
          label: index,
        };
      }

      return { ...q };
    });

    newLabels.forEach((q) => {
      if (q.parentId) {
        const parentQuestion = newLabels.find(
          (parentQ) => parentQ._id === q.parentId
        );
        if (parentQuestion) {
          q.label = parentQuestion.label;
        }
      }
    });
    const subLabels = new Map();
    newLabels.forEach((q) => {
      if (q.parentId) {
        if (!subLabels.has(q.parentId)) {
          subLabels.set(q.parentId, [q]);
        } else {
          subLabels.get(q.parentId).push(q);
        }
      }
    });

    // Create final array with parent questions
    const finalQuestions = newLabels.filter((q) => !q.parentId);

    // Add child questions in order
    subLabels.forEach((children, parentId) => {
      const parentIndex = finalQuestions.findIndex((q) => q._id === parentId);
      if (parentIndex !== -1) {
        children.sort((a, b) => a.label - b.label);
        children.forEach((child, idx) => {
          child.subLabel = idx + 1;
          finalQuestions.splice(parentIndex + idx + 1, 0, child);
        });
      }
    });

    // Update state
    state.questions = finalQuestions;
  },
  QUESTIONS_ORDER: (state) => {
    // Reorder the questions array
    const reorderedQuestions = [...state.questions];
    // Update labels based on the new order

    let index = 0;
    const newLabels = reorderedQuestions.map((q) => {
      if (!q.parentId) {
        index += 1;
        return {
          ...q,
          label: index,
        };
      }

      return { ...q };
    });

    newLabels.forEach((q) => {
      if (q.parentId) {
        const parentQuestion = newLabels.find(
          (parentQ) => parentQ._id === q.parentId
        );
        if (parentQuestion) {
          q.label = parentQuestion.label;
        }
      }
    });
    const subLabels = new Map();
    newLabels.forEach((q) => {
      if (q.parentId) {
        if (!subLabels.has(q.parentId)) {
          subLabels.set(q.parentId, [q]);
        } else {
          subLabels.get(q.parentId).push(q);
        }
      }
    });

    // Create final array with parent questions
    const finalQuestions = newLabels.filter((q) => !q.parentId);

    // Add child questions in order
    subLabels.forEach((children, parentId) => {
      const parentIndex = finalQuestions.findIndex((q) => q._id === parentId);
      if (parentIndex !== -1) {
        children.sort((a, b) => a.label - b.label);
        children.forEach((child, idx) => {
          child.subLabel = idx + 1;
          finalQuestions.splice(parentIndex + idx + 1, 0, child);
        });
      }
    });

    // Update state
    state.questions = finalQuestions;
  },
};
